module.exports = __webpack_public_path__ + "static/media/p5_s3.afb536d0.ogg";